import { useEffect } from "react";
import { closeModal, openModal } from "risa-oasis-ui_v2";
import { MODAL_DIALOG_ID } from "../constants";

/**
 * Registers the modal with the global `openModal` / `closeModal` registry
 * whenever the `isOpen` prop flips. Has no return value — pure side effect.
 *
 * Extracted so the orchestrator doesn't have to know the dialog id string
 * or worry about the open/close handshake.
 */
export const useModalLifecycle = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      openModal(MODAL_DIALOG_ID);
    } else {
      closeModal(MODAL_DIALOG_ID);
    }
  }, [isOpen]);
};
